import { useMutation } from "@tanstack/react-query";
import { createAxiosWithAuth } from "./middleware";

export const useSetClientBalance = () => {
  const axios = createAxiosWithAuth();

  return useMutation({
    mutationKey: ["set_balance"],
    mutationFn: async (query) => {
      return await axios.post("/settlement/setbalance", query);
    },
  });
};